import React, {useEffect, useMemo, useState} from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvCheckbox, AvCheckboxGroup, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import FollowupButtons from '../followup-buttons';
import '../followup.scss';

const MotherSymptomsStep: React.FC<StepComponentProps> = ({
                                                            formData,
                                                            updateFormData,
                                                            onNext,
                                                            onPrevious,
                                                            canGoBack,
                                                            canGoNext,
                                                            patientCaseType,
                                                            journey,
                                                            motherSymptomsData,
                                                          }) => {
  const [selectedSymptoms, setSelectedSymptoms] = useState<string[]>(formData.motherSymptoms || []);
  const [motherSymptomDetails, setMotherSymptomDetails] = useState(formData.motherSymptom || '');
  const [isOtherSelected, setIsOtherSelected] = useState(false);

  const patientCountryId = journey.patientCase?.patient?.countryId;

  // Get symptoms for mother from real data
  const motherSymptoms = useMemo(() => {
    return motherSymptomsData || [];
  }, [motherSymptomsData]);

  useEffect(() => {
    updateFormData({
      motherSymptoms: selectedSymptoms,
      motherSymptom: motherSymptomDetails
    });
  }, [selectedSymptoms, motherSymptomDetails]);

  useEffect(() => {
    // Update isOtherSelected when symptoms or selectedSymptoms change
    if (motherSymptoms.length > 0 && selectedSymptoms.length > 0) {
      const sortedSymptoms = [...motherSymptoms].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
      const lastSymptom = sortedSymptoms[sortedSymptoms.length - 1];
      setIsOtherSelected(selectedSymptoms.includes(lastSymptom?.id));
    } else {
      setIsOtherSelected(false);
    }
  }, [motherSymptoms, selectedSymptoms]);

  const handleSymptomChange = event => {
    // Sort symptoms by displayOrder and check if the last symptom (highest displayOrder) is selected
    const sortedSymptoms = [...motherSymptoms].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
    const lastSymptom = sortedSymptoms[sortedSymptoms.length - 1];
    setIsOtherSelected(selectedSymptoms.includes(lastSymptom?.id));
  };

  const handleSubmit = (event: any, values: any) => {
    onNext();
  };

  const handleMotherSymptomDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMotherSymptomDetails(e.target.value);
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="mb-4">Please select any additional mother symptoms.</h6>
        <AvForm onValidSubmit={handleSubmit}>
          <Row>
            <Col md="12">
              <AvGroup>
                <AvCheckboxGroup
                  name="motherSymptoms"
                  className="form-control"
                  style={{overflowY: 'auto', height: '400px'}}
                  value={selectedSymptoms}
                >
                  {motherSymptoms.length === 0 ? (
                    <p>No symptoms available for this emergency type.</p>
                  ) : (
                    [...motherSymptoms]
                      .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
                      .map(symptom => (
                        <AvCheckbox
                          key={symptom.id}
                          value={symptom.id}
                          label={symptom.enCondition}
                          onChange={handleSymptomChange}
                        />
                      ))
                  )}
                </AvCheckboxGroup>
              </AvGroup>
            </Col>
          </Row>
          {isOtherSelected && (
            <Row>
              <Col md="12">
                <AvGroup>
                  <Label for="motherSymptomDetails">Mother Symptom Details</Label>
                  <AvInput
                    type="text"
                    name="motherSymptomDetails"
                    id="motherSymptomDetails"
                    value={motherSymptomDetails}
                    onChange={handleMotherSymptomDetailsChange}
                    maxLength={255}
                    placeholder="Please specify the symptom details"
                    required
                  />
                </AvGroup>
              </Col>
            </Row>
          )}
          <FollowupButtons
            currentStep={2}
            totalSteps={10}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default MotherSymptomsStep;
